import getConfig from 'next/config';

import {getCategoryBy} from '~/src/utilities/feed/sitemap';
import {getCategoryUrl, getVideoUrl, getContentUrl} from '~/src/utilities/helpers/link';
import {ContentType} from '~/src/utilities/constants/types';

const {publicRuntimeConfig: config} = getConfig();

const getCategoriesInTree = (categoryId, categories) => {
    const result = [];

    let category = getCategoryBy(categories, {categoryId});
    if (category) {
        result.unshift(category);

        while ((category = getCategoryBy(categories, {categoryId: category.parent}))) {
            result.unshift(category);
        }
    }

    // finally, add front category (if not already done)
    category = getCategoryBy(categories, {fullUrlPath: config.frontCategory});
    if (category.categoryId !== categoryId) {
        result.unshift(category);
    }

    return result.filter((cat) => cat.fullUrlPath !== 'video' && cat.fullUrlPath !== 'lifestyle');
};

const createBreadcrumbItem = (fullUrlPath, title, position) => ({
    '@type': 'ListItem',
    position,
    item: {
        '@id': `${config.canonicalBaseUrl}${fullUrlPath}`,
        name: title
    }
});

/**
 *
 * @param {number} categoryId Feed ID for the current category
 * @param {string} categoryName Name of the current category
 * @param {object[]} categories Array of all the categories
 */
const getStructuredCategoryBreadcrumbs = (categoryId, categoryName, categories) => ({
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: getCategoriesInTree(categoryId, categories).map((category, index) =>
        createBreadcrumbItem(getCategoryUrl(category.fullUrlPath), category.categoryId !== categoryId ? category.name : categoryName, index + 1)
    )
});

/**
 *
 * @param {object} params Object containing url, type, name and main category as props
 * @param {object[]} categories Array of all the categories
 */
const getStructuredContentBreadcrumbs = ({url, type, name, mainCategory}, categories) => {
    const category = getCategoryBy(categories, {categoryId: mainCategory}) || getCategoryBy(categories, {fullUrlPath: config.frontCategory});
    const data = getStructuredCategoryBreadcrumbs(category.categoryId, category.name, categories);
    const contentUrl = type === ContentType.VIDEO ? getVideoUrl(url) : getContentUrl(url);

    data.itemListElement.push(createBreadcrumbItem(contentUrl, name, data.itemListElement.length + 1));

    return data;
};

export {getStructuredCategoryBreadcrumbs, getStructuredContentBreadcrumbs};
